
export enum DesignStyle {
    SITE_THEME = 'site-theme',
    BASIC = 'basic',
}

export interface Booking {
    title: string;
    userPrimaryEmail: string;
    startTime: string;
    user: {
        name: string;
    };
    videoCallUrl?: string;
    location?: string;
    uid: string;
    endTime: Date;
    attendees: Array<{
        name: string;
        email: string;
    }>;
}

export enum UrlAction {
    RESCHEDULE = 'reschedule',
    CANCEL = 'cancel',
}

export enum BookingStatus {
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
    CONFIRMED = 'CONFIRMED',
    RESCHEDULED = 'RESCHEDULED',
}